import React, { useState } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { useDispatch, useSelector } from 'react-redux';
import { Card, Alert } from "reactstrap";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { AiOutlineSearch } from "react-icons/ai";
import { adminAddUpdateAccountType } from '../../redux/actions/adminAddUpdateAccountTypeAction';
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useEffect } from 'react';
import { adminGetAccountTypeList } from '../../redux/actions/adminGetAccountTypeListAction';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
// import { Delete } from '@mui/icons-material';
import { makeStyles } from "@mui/styles";
import EditIcon from "@mui/icons-material/Edit";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Util from "../../validation";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminBankType = () => {

    const classes = useStyles();

    const [accountType, setaccountType] = useState('');
    const [addOpen, setaddOpen] = useState(false);
    const [addAccountType, setaddAccountType] = useState('');
    const [addUpdateState, setaddUpdateState] = useState(false);
    const [addUpdateRespDescription, setaddUpdateRespDescription] = useState('');
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [accountTypeList, setaccountTypeList] = useState([]);
    const [accountTypes, setaccountTypes] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [submitSet, setsubmitSet] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [editId, seteditId] = useState('')
    const [editAccountName, seteditAccountName] = useState('');
    const [editOpen, seteditOpen] = useState(false);
    const [tableData, settableData] = useState([]);
    const [shouldRefetchAccountTypes, setShouldRefetchAccountTypes] = useState(false); // New state to trigger refetch
    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const adminAddUpdateAccountTypeRes = useSelector(({ adminAddUpdateAccountType }) => adminAddUpdateAccountType);
    const adminGetAccountTypeListRes = useSelector(({ adminGetAccountTypeList }) => adminGetAccountTypeList);
    // var authToken = regenerateTokenRes.data.AuthToken;
     var authToken = regenerateTokenRes.data?.AuthToken;

    const dispatch = useDispatch();

    const handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'accountType') {
            setaccountType(value);
        }
    }

    // useEffect(() => {
    //     getAccountTypeList()
    // }, [])

    useEffect(() => {
        getAllBankType();
    }, [accountTypeList]);

    const getAllBankType = () => {
        if (addUpdateState) {
            if (adminAddUpdateAccountTypeRes.data.status === 'sucess') {
                settableData([].concat(adminGetAccountTypeListRes.data.customerMasterDetailsRequestVOList))
            }
            if (adminAddUpdateAccountTypeRes.data.status === 'failed') {
                if (
                    adminAddUpdateAccountTypeRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminAddUpdateAccountTypeRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
        setaddUpdateState(false);
    }

    const accountTypesData = [].concat(accountTypeList)
    const submitSearch = () => {
        setPage(0)

        accountTypesData.filter(ch => ch.accountName == accountType ? ch : '').length == 0 ?
            settableData([].concat(accountTypeList)) : settableData([].concat(accountTypeList.filter(ch => ch.accountName == accountType ? ch : '')))
    }

     // Handle response for adminGetAccountTypeList
    useEffect(() => {
        if (adminGetAccountTypeListRes.data) {
            if (adminGetAccountTypeListRes.data.status === 'success') {
                setaccountTypes(adminGetAccountTypeListRes.data.customerMasterDetailsRequestVOList);
                setaccountTypeList(adminGetAccountTypeListRes.data.customerMasterDetailsRequestVOList); // Also update accountTypeList for dropdown
                settableData(adminGetAccountTypeListRes.data.customerMasterDetailsRequestVOList); // Set table data initially
                setisLoading(false);
            } else if (adminGetAccountTypeListRes.data.status === 'failed') {
                setaccountTypes([]);
                setisLoading(false);
                if (adminGetAccountTypeListRes.data.description === "session out") {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                } else if (adminGetAccountTypeListRes.data.description === "Authorization failed") {
                    // Trigger token regeneration and then refetch account types
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                    setShouldRefetchAccountTypes(true); // Set flag to refetch after token regeneration
                }
            }
        }
    }, [adminGetAccountTypeListRes.data, dispatch, authToken, regenerateTokenRes.data.partnerId]);

      // Effect to refetch account types after token regeneration
    useEffect(() => {
        if (shouldRefetchAccountTypes && regenerateTokenRes.data?.status === 'success' && regenerateTokenRes.data?.AuthToken) {
            fetchAccountTypeList(regenerateTokenRes.data.AuthToken); // Use the new token
            setShouldRefetchAccountTypes(false); // Reset the flag
        }
    }, [shouldRefetchAccountTypes, regenerateTokenRes.data]);

    // const getAccountTypeResp = () => {
    //     if (adminGetAccountTypeListRes.data.status === 'success') {
    //         setaccountTypes(adminGetAccountTypeListRes.data.customerMasterDetailsRequestVOList);
    //         setisLoading(false);
    //     }
    //     if (adminGetAccountTypeListRes.data.status === 'failed') {
    //         setaccountTypes([]);
    //         setisLoading(false);
    //         if (
    //             adminGetAccountTypeListRes.data.description == "session out"
    //         ) {
    //             SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //         if (
    //             adminGetAccountTypeListRes.data.description == "Authorization failed"
    //         ) {
    //             regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //     }
    // }

    // useEffect(() => {
    //     getAccountTypeResp();
    // }, [adminGetAccountTypeListRes.data.status]);

    const addModalOpen = () => {
        setaddOpen(true)
    }

    const onInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'addAccountType') {
            // setaddAccountType(value);
            Util.alphaNumeric(value) ? setaddAccountType(value) : setaddAccountType(addAccountType);
        }
    }

    const addUpdateSubmitFunc = () => {
        setaddUpdateState(true);
        const req = {
            actionCustomerMasterRequestVO: {
                id: "",
                accountName: addAccountType
            }
        }
        dispatch(adminAddUpdateAccountType(req, authToken));
        setaddOpen(false);
        setaddAccountType()
    }

    const handleClose = () => {
        setaddOpen(false);
        setaddAccountType('');
    }

    const fetchAccountTypeList = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                id: "",
                accountName: ""
            }
        }
        dispatch(adminGetAccountTypeList(req, authToken))
    }


    // Initial fetch of account types
    useEffect(() => {
        // Only fetch if authToken is available
        if (authToken) {
            fetchAccountTypeList(authToken);
        }
    }, [authToken]); // Dependency on authToken to ensure it's available


    const addUpdateAccountTypeRespFunc = () => {
        if (addUpdateState) {
            if (adminAddUpdateAccountTypeRes.data.status === 'sucess') {
                setaddUpdateRespDescription(adminAddUpdateAccountTypeRes.data.description);
                setDropdownAccountType();
                setnotificationOpen(true);
                fetchAccountTypeList()
                // getAccountTypeList();
                // submitSearch();
            }
            if (adminAddUpdateAccountTypeRes.data.status === 'failed') {
                setaddUpdateRespDescription(adminAddUpdateAccountTypeRes.data.description);
                submitSearch();
                setnotificationOpen(true);
                if (
                    adminAddUpdateAccountTypeRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminAddUpdateAccountTypeRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        addUpdateAccountTypeRespFunc();
    }, [adminAddUpdateAccountTypeRes.data.status]);

    const handleNoticationClose = () => {
        setnotificationOpen(false)
        setaddUpdateRespDescription('')
    }

    const setDropdownAccountType = () => {
        if (adminGetAccountTypeListRes.data.status === 'success') {
            setaccountTypeList(adminGetAccountTypeListRes.data.customerMasterDetailsRequestVOList);
            submitSearch();
            setisLoading(false);
        }
        if (adminGetAccountTypeListRes.data.status === 'failed') {
            if (
                adminGetAccountTypeListRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                adminGetAccountTypeListRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }

    useEffect(() => {
        setDropdownAccountType();
    }, [adminGetAccountTypeListRes.data.status])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const editModal = (id, accountName) => {
        seteditId(id)
        seteditAccountName(accountName)
        seteditOpen(true);
    }

    const editHandleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'editId') {
            seteditId(value);
        }
        if (name === 'editAccountName') {
            seteditAccountName(value);
            Util.alphaNumeric(value) ? seteditAccountName(value) : seteditAccountName(editAccountName);
        }
    }

    const editSubmitFunc = () => {
        setaddUpdateState(true);
        const req = {
            actionCustomerMasterRequestVO: {
                id: editId,
                accountName: editAccountName
            }
        }
        dispatch(adminAddUpdateAccountType(req, authToken));
        seteditOpen(false);
    }

    const closeEditModal = () => {
        seteditOpen(false);
    }

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px",
                            textAlign: "center"
                        }}
                    >
                        <Grid item xs={12} md={4} sm={3} lg={5}></Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <CustomButton
                                variant="contained"
                                style={{
                                    padding: "8px"
                                }}
                                onClick={addModalOpen}
                            >
                                Add Bank Type
                            </CustomButton>
                        </Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <NavLink to="/index/mappingBankType">
                                <CustomButton
                                    variant="contained"
                                    style={{
                                        padding: "8px"
                                    }}
                                >
                                    Mapping Bank Type
                                </CustomButton>
                            </NavLink>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Select Bank Type"
                                fullWidth={true}
                                name="accountType"
                                value={accountType || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value="Select Bank Type"
                                    selected="Select Bank Type"
                                >
                                    Select Bank Type
                                </MenuItem>
                                {accountTypeList &&
                                    [].concat(accountTypeList).map((x, index) => (
                                        <MenuItem key={index} value={x.accountName}>
                                            {x.accountName}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={submitSearch}
                            >
                                Search
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>
                <div>
                    <Dialog open={addOpen} onClose={handleClose}>
                        <DialogTitle style={{ minWidth: "600px" }}>
                            Add Bank Type
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Bank Type"
                                fullWidth={true}
                                name="addAccountType"
                                value={addAccountType || ""}
                                onChange={onInputChange}
                            ></TextField>
                            {/* <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Country Code"
                                fullWidth={true}
                                name="addCountryCode"
                                value={addCountryCode || ""}
                                onChange={onInputChange}
                            ></TextField>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Country ISO"
                                fullWidth={true}
                                name="addCountryIso"
                                value={addCountryIso || ""}
                                onChange={onInputChange}
                            ></TextField>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Country Name"
                                fullWidth={true}
                                name="allCountries"
                                value={allCountries || ''}
                                onChange={handleChangeCountries}
                            >
                                <MenuItem
                                    value="Select Country"
                                    selected="Select Country"
                                >
                                    Select Country
                                </MenuItem>
                                {countries &&
                                    [].concat(countries).map((x, index) => (
                                        <MenuItem key={index} value={`${x.dial_code}-${x.code}-${x.label}`}>
                                            {x.label}
                                        </MenuItem>
                                    ))}
                            </TextField> */}

                        </DialogContent>
                        <DialogActions style={{ padding: "14px" }}>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={addUpdateSubmitFunc}
                            >
                                Save
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
                {
                    isLoading ? (<LoadingSpinner />) :
                        tableData == undefined ||
                            !tableData || tableData.length == 0 ||
                            adminGetAccountTypeListRes.data.status === 'NOT FOUND' ? (
                            <Card>
                                {/* <Typography variant="body1">Report Table</Typography> */}
                                <Grid
                                    container
                                    style={{
                                        padding: "10px"
                                    }}
                                >
                                    <Grid xs={12} sm={12} md={12} lg={12}>
                                        <Typography variant="body1" style={{ fontWeight: "700" }}
                                className="themeText"
                                        
                                        >
                                            Report Table
                                        </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={12} md={12} lg={12}>
                                        <Alert
                                            className="my-3 tableHeaderColor"
                                            variant="secondary"
                                            style={{ color: "white" }}
                                        >
                                            No Records Found!
                                        </Alert>
                                    </Grid>
                                </Grid>
                            </Card>
                        ) : (
                            <Card>
                                <Grid
                                    container
                                    style={{
                                        padding: "10px"
                                    }}
                                >
                                    <Grid xs={12} sm={12} md={12} lg={12}>
                                        <Typography variant="body1" style={{ fontWeight: "700" }}
                                className="themeText"
                                        
                                        >
                                            Report Table
                                        </Typography>
                                    </Grid>
                                    <TableContainer component={Paper} className="my-3">
                                        <Table
                                            className={classes.table}
                                            size="small"
                                            aria-label="a dense table"
                                        >
                                            <TableHead>
                                                <TableRow className="tableHeaderColor">
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        ID
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Bank Type
                                                    </TableCell>
                                                    <TableCell
                                                        colSpan={2}
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Action
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {tableData &&
                                                    []
                                                        .concat(tableData)
                                                        .slice(
                                                            page * rowsPerPage,
                                                            page * rowsPerPage + rowsPerPage
                                                        )
                                                        .map((row, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell align="center">
                                                                    {row.id}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.accountName}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() => editModal(row.id, row.accountName)}
                                                                    >
                                                                        <EditIcon style={{ color: "#fff" }} />
                                                                    </CustomButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={[].concat(tableData).length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </Grid>
                            </Card>
                        )
                }

                <div>
                    <Dialog open={editOpen} onClose={closeEditModal}>
                        <DialogTitle style={{ minWidth: "600px" }}>
                            Edit Bank Type
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                disabled
                                color="primary"
                                type="text"
                                label="Bank Type Id"
                                fullWidth={true}
                                name="editId"
                                value={editId || ""}
                                onChange={editHandleChange}
                            ></TextField>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Bank Type Name"
                                fullWidth={true}
                                name="editAccountName"
                                value={editAccountName || ""}
                                onChange={editHandleChange}
                            ></TextField>
                        </DialogContent>
                        <DialogActions style={{ padding: "14px" }}>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={closeEditModal}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={editSubmitFunc}
                            >
                                Save
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            </Layout>
            {adminAddUpdateAccountTypeRes.data.status == "sucess" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addUpdateRespDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminAddUpdateAccountTypeRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addUpdateRespDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminBankType